module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-main"
  }, [(_vm.currentPage === 'self') ? _c('div', {
    staticClass: "page-header"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_vm._v(_vm._s(this.$route.params.namespace))]), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v(_vm._s(_vm.$t("member.labels.members")))])]), _vm._v(" "), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.$t("member.labels.editMembers")))])]) : _c('div', {
    staticClass: "page-header"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_vm._v(_vm._s(_vm.currentPage === 'admin' ? 'Admin' : 'Reseller'))]), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('router-link', {
    attrs: {
      "to": ("/" + (_vm.$route.params.namespace) + "/" + _vm.currentPage + "/teams")
    }
  }, [_vm._v(_vm._s(_vm.$t("action.manageClientTeam")))])], 1), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item active"
  }, [_c('router-link', {
    attrs: {
      "to": ("/" + (_vm.$route.params.namespace) + "/" + _vm.currentPage + "/teams/" + (_vm.$route.params.subnamespace) + "/edit")
    }
  }, [_vm._v(_vm._s(_vm.$route.params.subnamespace))])], 1)]), _vm._v(" "), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.$t("member.labels.editMembers")))])]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body panel-form"
  }, [(_vm.isLoading) ? _c('loading-indicator') : _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAlert),
      expression: "showAlert"
    }],
    attrs: {
      "alertClass": "m-b-25 alert-dismissible",
      "type": ("" + ((_vm.successResponse) ? 'success' : 'danger')),
      "iconClass": ("" + ((_vm.successResponse) ? 'md-check' : 'md-close'))
    }
  }, [(_vm.successResponse) ? _c('span', [_vm._v(_vm._s(_vm.successResponse))]) : (_vm.errorResponse) ? _c('span', [_vm._v(_vm._s(_vm.errorResponse))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-section"
  }, [_c('form-group', {
    attrs: {
      "error": _vm.formErrors.first('name'),
      "autocomplete": "false"
    }
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.labels.displayName")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('account.labels.displayName')
    },
    domProps: {
      "value": _vm._s(_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "error": _vm.formErrors.first('email')
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.labels.email")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "email",
      "placeholder": _vm.$t('account.labels.email'),
      "autocomplete": "false",
      "disabled": !_vm.showEmail
    },
    domProps: {
      "value": _vm._s(_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('form-group', [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.labels.password")))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showPassword),
      expression: "!showPassword"
    }],
    staticClass: "btn btn-icon btn-block btn-primary btn-outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.changePassword(_vm.showPassword)
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("member.action.changePassword")) + "\n                  ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.showPassword),
      expression: "showPassword"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('account.labels.password')
    },
    domProps: {
      "value": _vm._s(_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPassword),
      expression: "showPassword"
    }],
    staticClass: "btn btn-icon btn-block btn-link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.changePassword(_vm.showPassword)
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("member.action.hidePassword")) + "\n                  ")])]), _vm._v(" "), _c('form-group', [_c('label', {
    attrs: {
      "for": "role"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.labels.role")))]), _vm._v(" "), _c('div', {
    staticClass: "radio-custom radio-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.role),
      expression: "user.role"
    }],
    attrs: {
      "type": "radio",
      "value": "manager"
    },
    domProps: {
      "checked": _vm._q(_vm.user.role, "manager")
    },
    on: {
      "click": function($event) {
        _vm.user.role = "manager"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "user"
    }
  }, [_vm._v("Manager\n                    ")])]), _vm._v(" "), (_vm.showUserRole) ? _c('div', {
    staticClass: "radio-custom radio-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.role),
      expression: "user.role"
    }],
    attrs: {
      "type": "radio",
      "value": "user"
    },
    domProps: {
      "checked": _vm._q(_vm.user.role, "user")
    },
    on: {
      "click": function($event) {
        _vm.user.role = "user"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "user"
    }
  }, [_vm._v("User "), _c('span', {
    staticClass: "grey-400"
  }, [_vm._v(_vm._s(_vm.$t("member.role.user.textGuide")))])])]) : _vm._e()])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "btn btn-success",
    class: {
      'btn-default': _vm.isSubmiting
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.isSubmiting
    }
  }, [(_vm.isSubmiting) ? _c('div', {
    staticClass: "loader vertical-align-middle loader-circle loader-form"
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t("member.labels.editMembers")) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [(_vm.user.is_enabled) ? _c('button', {
    staticClass: "btn btn-link pull-xs-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.enableAccount(false)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("member.action.deactivateAccount")) + "\n              ")]) : _c('button', {
    staticClass: "btn btn-link pull-xs-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.enableAccount(true)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("member.action.enableAccount")) + "\n              ")])])])])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-09b87da0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teams/TeamMemberEditor.vue
// module id = 503
// module chunks = 1